import { FC } from 'react';

type SwitchType = {
  active: boolean;
  label: string;
  handleClick: () => void;
};

const Switch: FC<SwitchType> = ({ active, handleClick, label }) => {
  return (
    <div>
      <label className="block h-full mb-1 sm:text-[14px] text-[#666]">
        {label}
      </label>
      <div
        className={`md:w-14 md:h-7 w-12 h-6 flex items-center rounded-full p-1 cursor-pointer transition-all ${
          !active ? 'bg-gray-300' : 'bg-[#333]'
        }`}
        onClick={() => handleClick()}
      >
        {/* Switch */}
        <div
          className={`bg-white md:w-6 md:h-6 h-5 w-5 rounded-full shadow-md transform transition-all ${
            active ? 'transform translate-x-6' : null
          }`}
        ></div>
      </div>
    </div>
  );
};

export default Switch;
